import { PaymentFrequencyEnumLabels } from "@boundless/bl-api-client/customer/models/PaymentFrequencyEnumLabels"
import { SecurityEnumLabels } from "@boundless/bl-api-client/customer/models/SecurityEnumLabels"
import { PencilIcon, XIcon } from "lucide-react"

import { formatCurrency } from "@/lib/forms/utils"

import type { DebtSchedule } from "@boundless/bl-api-client/customer/models"

type DebtEntryProps = {
  debt: DebtSchedule
  startEditing: (debt: DebtSchedule) => void
  handleDelete: (uuid: string) => void
}

export function DebtEntry({
  debt,
  startEditing,
  handleDelete,
}: DebtEntryProps) {
  const fields = [
    { label: "Lender Name", value: debt.lenderName },
    { label: "Original Amount", value: formatCurrency(debt.originalAmount) },
    { label: "Funded Date", value: debt.fundedDate },
    { label: "Maturity Date", value: debt.maturityDate },
    { label: "Current Balance", value: formatCurrency(debt.currentBalance) },
    { label: "Payment Amount", value: formatCurrency(debt.paymentAmount) },
    {
      label: "Payment Frequency",
      value: PaymentFrequencyEnumLabels[debt.paymentFrequency],
    },
    { label: "Security", value: SecurityEnumLabels[debt.security] },
  ]

  return (
    <div className="grid grid-cols-1 gap-1 py-3 lg:grid-cols-[repeat(8,minmax(7.5rem,1fr))_5rem] lg:items-start lg:gap-2">
      {fields.map(({ label, value }) => (
        <div key={label} className="py-1 lg:py-3">
          <div className="grid grid-cols-[minmax(0,8.5rem)_minmax(0,1fr)] gap-2 lg:block">
            <span className="text-muted-foreground text-xs font-medium lg:hidden">
              {label}
            </span>
            <span>{value}</span>
          </div>
        </div>
      ))}

      <div className="pt-2 text-left lg:py-3 lg:text-right">
        <div className="flex justify-start space-x-2 lg:justify-end">
          <button
            className="rounded p-1 hover:bg-gray-100"
            type="button"
            onClick={() => {
              startEditing(debt)
            }}
          >
            <PencilIcon className="h-5 w-5 text-gray-500" />
          </button>
          <button
            className="text-destructive rounded p-1 hover:bg-gray-100"
            type="button"
            onClick={() => handleDelete(debt.uuid)}
          >
            <XIcon className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  )
}
